var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-left":"auto","margin-right":"auto"},style:({
    width: _vm.wrapWidth < 1376 ? '90%' : '75%'
  })},[_vm._t("title",function(){return [(_vm.title)?_c('div',{staticClass:"text-center",staticStyle:{"font-size":"30px","font-weight":"500","color":"#333"}},[_vm._v(_vm._s(_vm.title))]):_vm._e()]}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17b6d7bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/components/pc/home/dss/dss-card.vue
// module id = null
// module chunks = 